/* eslint-disable @typescript-eslint/naming-convention */
import { Router } from '@angular/router';
import { EventsService } from './../../services/events.service';
import { RestService } from './../../services/rest.service';
import { Component, OnInit } from '@angular/core';
import { IonRouterOutlet, MenuController, Platform } from '@ionic/angular';
import { App } from '@capacitor/app';
import { BackButtonService } from 'src/app/services/back-button.service';

export interface ProcessingLine {
  Tekst: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  public authorized = true;
  public uid: string;
  public authorizing = false;
  public username: string;
  public enterKey: string;
  public orders: any[] = [];
  public tabValue = 1;
  public storageOrders: any[] = [];
  public processingOrders: any[] = [];
  public loading = false;

  // Processing lines from dictionary
  public processingLines: ProcessingLine[] = [];
  public selectedLine: string | null = null;

  constructor(
    public rest: RestService,
    private events: EventsService,
    public router: Router,
    private routerOutlet: IonRouterOutlet,
    public platform: Platform,
    private backButtonService: BackButtonService,
    private menuCtrl: MenuController
  ) {}

  public get filteredProcessingOrders(): any[] {
    if (this.selectedLine === null) {
      return this.processingOrders;
    }
    return this.processingOrders.filter(
      (order: any) => order.line === this.selectedLine
    );
  }

  doRefresh(event) {
    Promise.all([this.rest.getOrders(), this.rest.getProcessingLines()])
      .then(([orders, lines]: [any, ProcessingLine[]]) => {
        this.orders = orders;
        this.storageOrders = orders.filter(
          (order: any) => order.storageOrder === true
        );
        this.processingOrders = orders.filter(
          (order: any) => order.storageOrder === false
        );
        this.processingLines = lines || [];
        if (this.processingLines.length > 0 && this.selectedLine === null) {
          this.selectedLine = this.processingLines[0].Tekst;
        }
        event.target.complete();
      })
      .catch(() => {
        event.target.complete();
      });
  }

  login(key) {
    this.rest.authUser(key).then((users: any) => {
      this.authorizing = false;
      if (users) {
        this.authorized = true;
        this.username = users.username;
      }
    });
  }

  ngOnInit() {
    this.platform.backButton.subscribeWithPriority(-1, () => {
      if (!this.routerOutlet.canGoBack()) {
        App.exitApp();
      }
    });
    this.backButtonService.hideBackButton();
    this.getData();

    /* LOCAL DEV */
    //this.uid ='227ff1e9-c6fa-fe9d-3594-430976567888';
    //this.uid ='xyz';
    //this.login(this.uid);

    this.events.itemSaved.subscribe((success) => {
      if (success) {
        this.getData(false);
      }
    });
  }

  ionViewWillEnter(): void {
    this.menuCtrl.enable(true);
    this.menuCtrl.close();
    this.backButtonService.hideBackButton();
  }

  public getData(showLoading = true) {
    if (showLoading) {
      this.loading = true;
    }

    Promise.all([this.rest.getOrders(), this.rest.getProcessingLines()])
      .then(([orders, lines]: [any, ProcessingLine[]]) => {
        this.orders = orders;
        this.storageOrders = orders.filter(
          (order: any) => order.storageOrder === true
        );
        this.processingOrders = orders.filter(
          (order: any) => order.storageOrder === false
        );
        this.processingLines = lines || [];
        // Select first line by default if available
        if (this.processingLines.length > 0 && this.selectedLine === null) {
          this.selectedLine = this.processingLines[0].Tekst;
        }
      })
      .catch(() => {
        // Fallback empty on error
        this.processingLines = [];
      })
      .finally(() => {
        if (showLoading) {
          this.loading = false;
        }
      });
  }

  public selectLine(lineTekst: string): void {
    this.selectedLine = lineTekst;
  }

  public details(orderId: number) {
    this.router.navigate(['details', orderId]);
  }

  public processingSheet(orderId: number) {
    this.router.navigate(['processing-sheet', orderId], {
      queryParams: { line: this.selectedLine },
    });
  }
}
